if(typeof jsdom === 'undefined') { var e = new Error("Cannot find module 'jsdom'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = jsdom;